<script>
  let { children, width = "auto", align = "left", class: className, containerClass, ...rest } = $props()
  import { cn } from '@lib/utils'

  let baseClass = "px-4 py-3 text-smaller text-gray-600/90 border-r border-gray-100 last:border-r-0 leading-5 truncate"
  let alignClass = $derived(align === "right" ? "text-right" : align === "center" ? "text-center" : "text-left")
  let cellClass = $derived(cn(baseClass, alignClass, className))
</script>

<td {...rest} class={cellClass} style="width: {width}">
  {#if containerClass}
    <div class={cn("flex items-center justify-center gap-2", containerClass)}>
      {@render children?.()}
    </div>
  {:else}
    {@render children?.()}
  {/if}
</td>